import type React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface CommentEditFormProps {
  value: string;
  isSubmitting: boolean;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  showMentionWarning: boolean;
  cancelButtonVariant?: "ghost" | "outline";
}

export const CommentEditForm: React.FC<CommentEditFormProps> = ({
  value,
  isSubmitting,
  onChange,
  onSave,
  onCancel,
  showMentionWarning,
  cancelButtonVariant = "outline",
}) => {
  const { t } = useTranslation();

  return (
    <div className="text-sm font-normal text-variable-collection-black-gray">
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full resize-none rounded border p-2"
        rows={10}
        disabled={isSubmitting}
      />
      {showMentionWarning && (
        <div className="mt-2 rounded border border-amber-200 bg-amber-50 p-2 text-sm text-amber-700">
          {t("common.editMentionNoNotificationWarning")}
        </div>
      )}
      <div className="mt-2 flex gap-2">
        <Button variant="teal" onClick={onSave} disabled={isSubmitting}>
          {t("common.save")}
        </Button>
        <Button
          variant={cancelButtonVariant}
          onClick={onCancel}
          disabled={isSubmitting}
        >
          {t("common.cancel")}
        </Button>
      </div>
    </div>
  );
};
